"use client";
import minusIcon from "@/assets/landingPage/faq/minus-icon.svg";
import plusIcon from "@/assets/landingPage/faq/plus-icon.svg";
import { parseColorTextToJSX } from "@/utils/utils";
import Image from "next/image";
import { useState } from "react";
import TextReveal from "../animation/TextReveal";

const Faq = ({ data, faqData }) => {
  const [openIndex, setOpenIndex] = useState(0);
  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="faq section_space_py">
      <div className="custom-container mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-7.5 items-center">
          <TextReveal delay={0.2} duration={1.2} direction="left">
            <div className="me-0 lg:me-[20px] xl:me-[50px] 2xl:me-[112px]">
              <div className="h-[300px] sm:h-[500px] md:h-[700px] w-full">
                <Image
                  src={data?.image}
                  alt="faq"
                  width={700}
                  height={700}
                  unoptimized
                  className="h-full w-full object-cover rounded-2xl"
                />
              </div>
            </div>
          </TextReveal>
          <TextReveal delay={0.2} duration={1.2} direction="right">
            <div>
              <div className="">
                <div className="">
                  <div className="mb-8 lg:mb-12">
                    <h1 className="title-design mb-4">
                      {parseColorTextToJSX(data?.faq_title)}
                    </h1>
                    <p className="text-[14px] sm:text-base text-user-paragraph">
                      {data?.faq_subtitle}
                    </p>
                  </div>
                  <div className="space-y-0">
                    {faqData.map((faq, index) => (
                      <div
                        key={index}
                        className="bg-white border-t-2 border-dotted border-gray-200"
                      >
                        <button
                          onClick={() => toggleFAQ(index)}
                          className="w-full py-4 lg:py-5 xl:py-7.5 flex items-center justify-between text-left"
                        >
                          <div className="flex items-start gap-4 flex-1">
                            <span className="text-user-primary font-semibold text-lg flex-shrink-0">
                              {String(index + 1).padStart(2, "0")}
                            </span>
                            <h3 className="text-base xl:text-lg font-bold text-user-text ltr:flex-1">
                              {faq?.title}
                            </h3>
                          </div>
                          <div className="ms-4 flex-shrink-0">
                            <Image
                              src={openIndex === index ? minusIcon : plusIcon}
                              alt={openIndex === index ? "Close" : "Open"}
                              width={16}
                              height={16}
                              className="transition-opacity duration-200"
                            />
                          </div>
                        </button>

                        <div
                          className={`grid transition-all duration-300 ease-in-out ${
                            openIndex === index
                              ? "grid-rows-[1fr] opacity-100"
                              : "grid-rows-[0fr] opacity-0"
                          }`}
                        >
                          <div className="overflow-hidden">
                            <div className="px-6 pb-7.5 ps-[38px]">
                              <p className="paragraph-design leading-relaxed">
                                {faq?.description}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </TextReveal>
        </div>
      </div>
    </div>
  );
};

export default Faq;
